import { Controller } from '@hotwired/stimulus'

import $ from 'jquery'
import "vendor/timeago"

export default class TimeagoController extends Controller {
  connect() {
    $(this.element).timeago().tooltip()
  }
}
